export default "__VITE_ASSET__DJ_WKiBG__"